
import store from '../../config/store'
import Alert from '../../components/Alert.vue'
import Datepicker from '../../components/Datepicker.vue'
import PhoneInput from '../../components/PhoneInput.vue'

export default {
  components: {
    'datepicker': Datepicker,
    'component-alert': Alert,
    PhoneInput
  },

  data: () => ({
    store,
    index: 0,
    values: JSON.parse(JSON.stringify(store.sidepanel.dataModel.values)),
    disabled: {
      to: new Date()
    },
    formSubmited: false
  }),

  computed: {
    initialValues () {
      return store.sidepanel.dataModel.values.filter(value => value.beneficiary.id !== null)
    },

    currentTransfer () {
      return this.values[this.index].transfer
    },

    currentBeneficiary () {
      return this.values[this.index].beneficiary
    },

    currentBeneficiaryLabel () {
      const iban = this.currentBeneficiary.account_number_formatted || this.currentBeneficiary.iban
      return this.currentBeneficiary.label + ' - ' + iban
    },

    validateEmailRules () {
      return this.currentTransfer.send_notification && this.currentTransfer.beneficiary.email ? 'required|email' : 'email'
    },

    totalAmount () {
      var totalAmount = 0
      for (var i = 0; i < this.values.length; i++) {
        if (!isNaN(parseFloat(this.values[i].transfer.amount))) {
          totalAmount += parseFloat(this.values[i].transfer.amount)
        }
      }
      return totalAmount
    }
  },

  mounted () {
    this.index = this.values.indexOf(this.values.find(value => value.id === store.sidepanel.dataModel.index))
    this.$validator.validateAll()
  },

  destroyed () {

  },

  methods: {

    mod (x, n) {
      return (x % n + n) % n
    },

    getPreviousTransfer () {
      this.index = this.mod(this.index - 1, this.values.length)
    },

    getNextTransfer () {
      this.index = this.mod(this.index + 1, this.values.length)
    },

    onValidate () {
      this.formSubmited = true

      this.$validator.validateAll().then(result => {
        if (result) {
          for (let i = 0; i < this.values.length; i++) {
            if (this.initialValues[i].beneficiary.email !== this.values[i].beneficiary.email || this.initialValues[i].beneficiary.phone_number !== this.values[i].beneficiary.phone_number) {
              // TODO Update beneficiary when email or phone has changed
            }
          }
          this.values.forEach(value => {
            value.transfer.amount = parseFloat(value.transfer.amount)
          })
          this.$bus.$emit('on-edit-transfers-success', this.values)
          this.hideSidePanel()
        }
      })
    }
  }
}
